// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-19T12:18:03+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190498
//    Project:        555
//    Environment:    5341 - master
//    MD5:            411aebe010730c83f7a0570a08d4d193
//    Signature:      eyJpdiI6IndkeDRLRGpiTStTbUVEbStDNVZzWmc9PSIsInZhbHVlIjoiR1BQa1wvVWorc3pHcE5ESE5OQWJiTjZjcEdsc1NzZXppOUVlNWhcL25FZEVVRVdVd002aHE0VHdPdFd4SGRpMGhJZkhNT1JQZlwvejI4YzRKZHdKVkFTZWJRV3RadTFIakE4Rkx5R3FUb2l2ZVlvUHk5R2llVk90ZHMzdXN3NWlxK1dlalpxbHhieVRqeGRNR3IzZURwZXBNVktKVlRLWGh4YkxaMUJISG1nRTVtSmt0SmZSMHZqXC81VmdMT1Y2QkRKaHo2WVJvT3JJUXpNOVhONm1FWlZcL092M1kzeHJRZ3NTeG51MHVnQnQwQ0VpWVlmVzdqRWlTOVF3SnV2UGFcL3ZuZ2RLM3hMXC9WSkRTUkttWFJFM2lxazEzUG9NcnBKRFdncTNOTGM4MVwvc3BVQmZQUFA4bXpaZDYwamk1V1BEcDNnRnBDdzFGcmpLS1VBcWErc2JpNjErc1wvMFpQa2xqVDJNd2o3Z3hJRUlCZ0gwT2FRYWF5OXk0aFd6cVFCY25hNEZlajFBRW1kRVc5a1E0S1o5Q2JqSm1jdz09IiwibWFjIjoiMmRhYzQwZjdlMjEzMWEwYmRhODRjNDRiZWJiZTYzMTVmMzg1ZjVmNzI3ODhjOGNiYmVkZTA3YjJkNzI0YTY0MiJ9
document.addEventListener("DOMContentLoaded", () => {
  const icons = document.querySelectorAll(".icon--loyalty");

  if (icons) {
    icons.forEach((icon) => {
        const frames = icon.querySelectorAll(".frame");
        if (frames.length === 0) return;

        const interval = 95;
        const finalHold = 3000;
        const fadeDuration = 500;

        let current = 0;

        function showFrame(index) {
        frames.forEach((frame, i) => {
            frame.style.opacity = i === index ? "1" : "0";
        });
        }

        function animateFrames() {
        showFrame(current);

        const isLast = current === frames.length - 1;
        const delay = isLast ? finalHold : interval;

        setTimeout(() => {
            if (isLast) {
            // Fade out last frame
            frames[current].style.opacity = "0";
            setTimeout(() => {
                current = 0;
                animateFrames();
            }, fadeDuration);
            } else {
            current++;
            animateFrames();
            }
        }, delay);
        }

        animateFrames();
    });
    }
});
